import { LOCAL_STORAGE } from '~/plugins/constants/localStorage';
import { getLocalStorage, removeLocalStorage } from '~/plugins/functions/localStorage';

const CHECK_INTERVAL_MS = 10_000;

export const useSessionExpiry = () => {
  let intervalId: ReturnType<typeof setInterval> | null = null;

  const logout = () => {
    removeLocalStorage(LOCAL_STORAGE.OAUTH_ACCESS_TOKEN);
    removeLocalStorage(LOCAL_STORAGE.SESSION_EXPIRY);
    window.location.reload();
  };

  const checkExpiry = () => {
    const expiry = getLocalStorage(LOCAL_STORAGE.SESSION_EXPIRY);
    if (!expiry) {
      return;
    }

    const expiryMs = Number(expiry) < 1e12 ? Number(expiry) * 1000 : Number(expiry);
    const remainingMs = expiryMs - Date.now();
    const remainingSec = Math.round(remainingMs / 1000);

    if (remainingMs <= 0) {
      logout();
    } 
  };

  onMounted(() => {
    checkExpiry();
    intervalId = setInterval(checkExpiry, CHECK_INTERVAL_MS);
  });

  onUnmounted(() => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  });
};
